import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';
import { checkBulkFieldTooltip } from '../utils/check-bulk-field-tooltip';

@Component({
  selector: 'pp-bulk-field-percentage',
  templateUrl: './bulk-field-percentage.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldPercentageComponent implements OnChanges {
  @Input() ppCustomField: TCustomField;
  @Input() ppCustomFields: TBulkCustomFields<number>;
  @Input() ppFieldId: string;
  @Input() ppCustomFieldsExtended: TBulkCustomFieldsExtended<number>;
  @Input() ppWorkspaceId: string;
  @Input() ppDisabled = false;

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;

  tooltipText: string;
  disabled = false;

  ngOnChanges() {
    this.tooltipText = checkBulkFieldTooltip(this.ppCustomField);
    this.disabled = this.ppDisabled || this.ppCustomField.lockedValue;
  }

  updatePercentage(percentage: string, field: TCustomField): void {
    this.ppCustomFields[field.id] = +percentage;

    this.ppCustomFieldsExtended[field.id] = {
      value: this.ppCustomFields[field.id],
      label: field.label,
      type: field.type,
    };

    this.ppCustomFieldsChange.emit(this.ppCustomFields);
    this.ppCustomFieldsExtendedChange.emit(this.ppCustomFieldsExtended);
  }
}
